
import { computed, defineComponent } from "vue";

import {
  ColumnDefinition,
  useDataTable,
  DataTable,
  BaseButton,
  DeleteIcon,
  EditIcon,
  CountButton,
} from "@tager/admin-ui";
import { useResourceDelete } from "@tager/admin-services";
import { Page } from "@tager/admin-layout";

import { deleteBasisProduct, getBasisProductList } from "@/services/requests";
import { BasisProductType } from "@/typings/model";
import {
  getFieldListUrl,
  getProductListUrl,
  getBasisProductFormUrl,
} from "@/utils/paths";
import { getWebsiteOrigin } from "@/utils/common";

const COLUMN_DEFS: Array<ColumnDefinition<BasisProductType>> = [
  {
    id: 1,
    name: "ID",
    field: "id",
    style: { width: "50px", textAlign: "center" },
    headStyle: { width: "50px", textAlign: "center" },
  },
  {
    id: 2,
    name: "Название",
    field: "name",
  },
  {
    id: 3,
    name: "",
    field: "products",
    style: { width: "146px", whiteSpace: "nowrap" },
    headStyle: { width: "146px" },
  },
  {
    id: 4,
    name: "Действия",
    field: "actions",
    style: { width: "101px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "101px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "BasisProductList",
  components: {
    Page,
    DataTable,
    BaseButton,
    DeleteIcon,
    EditIcon,
    CountButton,
  },
  setup() {
    const {
      isLoading: isBasisProductListLoading,
      rowData: productList,
      errorMessage,
      searchQuery,
      handleChange,
      pageNumber,
      pageCount,
      pageSize,
      fetchEntityList: fetchBasisProductList,
    } = useDataTable<BasisProductType>({
      fetchEntityList: (params) =>
        getBasisProductList({
          query: params.searchQuery,
          pageNumber: params.pageNumber,
          pageSize: params.pageSize,
        }),
      initialValue: [],
      pageSize: 100,
      resourceName: "Basis Product list",
    });

    const { handleResourceDelete: handleBasisProductDelete, isDeleting } =
      useResourceDelete({
        deleteResource: deleteBasisProduct,
        resourceName: "Basis Product",
        onSuccess: fetchBasisProductList,
      });

    const isRowDataLoading = computed<boolean>(
      () => isBasisProductListLoading.value
    );

    function isBusy(productId: number): boolean {
      return isDeleting(productId) || isRowDataLoading.value;
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: productList,
      isRowDataLoading,
      errorMessage,
      isBusy,
      handleBasisProductDelete,
      getBasisProductFormUrl,
      getFieldListUrl,
      getProductListUrl,
      getWebsiteOrigin,
      searchQuery,
      handleChange,
      pageNumber,
      pageCount,
      pageSize,
    };
  },
});
